import router from "../../router";

export default {
    state: {
        isCollapse: undefined, // 导航栏收缩状态
        menuLoaded: undefined, // 菜单是否初始化
        submenuList: [],
        menuList: [],
        // homeMenuList: [],
        tabList: [],
        tabExclude: [/homeDashboard/, "refresh"],
        moreBreadcrumb: null,
        homePath: undefined
    },
    getters: {
        getCollapseStatus: (state) => {
            if (state.isCollapse === undefined) {
                let sIsCollapse = sessionStorage.getItem("isCollapse");
                state.isCollapse = sIsCollapse === "true" ? true : false;
            }
            return state.isCollapse;
        },

        getMenuList: state => {
            if (state.menuList.length === 0) {
                let sMenuList = JSON.parse(sessionStorage.getItem('menuList'))
                state.menuList = sMenuList ? sMenuList : []
            }
            return state.menuList
        },
        getHomePath: state => {
            if (!state.homePath) {
                let sHomePath = sessionStorage.getItem('homePath')
                state.homePath = sHomePath;
            }
            return state.homePath
        },
        // getMenuList: (state) => {
        //     let submenuList=[]
        //     if (state.submenuList.length === 0) {
        //         let sMenuList = JSON.parse(sessionStorage.getItem("menuList"));
        //         state.submenuList = sMenuList ? sMenuList : [];
        //     }
        //     state.submenuList.forEach(element => {
        //         console.log(element.meta.title,"element")
        //         if(element.meta.title!="首页"){
        //             submenuList.push(element)
        //          }
        //     });
        //     state.submenuList=submenuList
        //     console.log(state.submenuList,"state.submenuList")
        //     return state.submenuList;
        // },
        // getHomeMenuList: (state) => {
        //     let homeMenuList = []
        //     if (state.homeMenuList.length === 0) {
        //         let sMenuList = JSON.parse(sessionStorage.getItem("menuList"));
        //         state.homeMenuList = sMenuList ? sMenuList : [];
        //     }
        //     state.homeMenuList.forEach(element => {
        //         if (element.meta.title == "首页") {
        //             homeMenuList.push(element)
        //         }
        //     });
        //     state.homeMenuList = homeMenuList
        //     console.log(state.homeMenuList, "state.homeMenuList")
        //     return state.homeMenuList;
        // },
        getMenuLoaded: (state) => {
            if (state.menuLoaded === undefined) {
                let sMenuLoaded = sessionStorage.getItem("menuLoaded");
                state.menuLoaded = sMenuLoaded === "true" ? true : false;
            }
            return state.menuLoaded;
        },
        getTabList: (state) => {
            if (state.tabList.length === 0) {
                let sTabList = JSON.parse(sessionStorage.getItem("tabList"));
                state.tabList = sTabList ? sTabList : [];
            }
            return state.tabList;
        },
        getTabExclude: (state) => {
            if (state.tabExclude.length === 0) {
                let stabExclude = JSON.parse(sessionStorage.getItem("tabExclude"));
                state.tabExclude = stabExclude ? stabExclude : [];
            }
            return state.tabExclude;
        },
        getMoreBreadcrumb: (state) => {
            return state.moreBreadcrumb;
        },
    },
    mutations: {
        SWITCH_COLLAPSE: (state, playload) => {
            state.isCollapse = playload;
            sessionStorage.setItem("isCollapse", state.isCollapse);
        },
        SWITCH_MENU_LOADED: (state, playload) => {
            state.menuLoaded = playload;
            sessionStorage.setItem("menuLoaded", state.menuLoaded);
        },
        SET_MENU_LIST: (state, playload) => {
            state.menuList = [...playload];
            sessionStorage.setItem("menuList", JSON.stringify(playload));
        },
        SET_HOME_PATH: (state, playload) => {
            state.homePath = playload;
            sessionStorage.setItem("homePath", playload);
        },
        OPEN_TAB: (state, playload) => {
            if (
                playload.name &&
                state.tabList.findIndex((t) => t.fullPath === playload.fullPath) ===
                -1 &&
                playload.name !== "refresh"
            ) {
                const { name, meta, path, query, params, fullPath } = playload;
                state.tabList.push({ name, meta, path, query, params, fullPath });
            }
            sessionStorage.setItem("tabList", JSON.stringify(state.tabList));
        },
        CLOSE_TAB: (state, playload) => {
            const DEL_INDEX = state.tabList.findIndex((t) => t.fullPath === playload);
            state.tabList.splice(DEL_INDEX, 1);
            sessionStorage.setItem("tabList", JSON.stringify(state.tabList));
            const CURRENT_TAB = state.tabList[state.tabList.length - 1];
            router.currentRoute.fullPath !== CURRENT_TAB.fullPath ?
                router.push({
                    path: CURRENT_TAB.path,
                    query: {...CURRENT_TAB.query },
                }) :
                "";
        },
        CLOSE_ALL: (state, playload) => {
            // playload传homeUrl
            const DASHBOARD = state.tabList.find((t) => t.fullPath === playload);
            state.tabList = [DASHBOARD];
            if (DASHBOARD) {
                state.tabList = [DASHBOARD];
            } else state.tabList = [];
            state.tabExclude = [/homeDashboard/, "refresh"];
            sessionStorage.setItem("tabList", JSON.stringify(state.tabList));
            sessionStorage.setItem("tabExclude", JSON.stringify(state.tabExclude));
        },
        CLOSE_OTHERS: (state, playload) => {
            const CURRENT_TAB = state.tabList.find(
                (t) => t.fullPath === playload.fullPath
            );
            const DASHBOARD = state.tabList.find(
                (t) => t.fullPath === playload.homeUrl
            );
            state.tabList = [DASHBOARD, CURRENT_TAB];
            state.tabExclude = [/homeDashboard/, "refresh", CURRENT_TAB.name];
            sessionStorage.setItem("tabList", JSON.stringify(state.tabList));
            sessionStorage.setItem("tabExclude", JSON.stringify(state.tabExclude));
        },
        CLOSE_RIGHT: (state, playload) => {
            const CURRENT_INDEX = state.tabList.findIndex(
                (t) => t.fullPath === playload
            );
            state.tabList = state.tabList.slice(0, CURRENT_INDEX + 1);
            state.tabExclude = state.tabExclude.slice(0, CURRENT_INDEX + 3);
            sessionStorage.setItem("tabList", JSON.stringify(state.tabList));
            sessionStorage.setItem("tabExclude", JSON.stringify(state.tabExclude));
        },
        REFRESH_TAB: (state, playload) => {
            const TAB = state.tabList.find((t) => t.fullPath === playload);
            state.tabExclude.push(TAB.name);
            sessionStorage.setItem("tabExclude", JSON.stringify(state.tabExclude));
            router.push({
                path: "/refresh",
                query: {
                    path: TAB.path,
                    query: JSON.stringify({
                        ...TAB.query,
                    }),
                },
            });
        },
        RESET_APP: (state) => {
            state.isCollapse = undefined;
            state.menuLoaded = undefined;
            state.menuList = [];
            state.tabList = [];
            state.tabExclude = ["home-dashboard", "refresh"];
        },
        SET_MORE_BREADCRUMB: (state, playload) => {
            state.moreBreadcrumb = playload;
        },
    },
    actions: {},
};